import React from 'react';
import classNames from 'classnames';

import MyHealthLogo from 'src/assets/myhealth-logo.svg?react';
import { XClose } from "@untitled-ui/icons-react";
import { ProgressBar } from './ProgressBar';
import { useExit } from 'src/hooks/useExit';

type Props = {
    hideCloseButton?: boolean | null,
    progressBar?: boolean,
    className?: string;
}

export function Header({ hideCloseButton, progressBar, className }: Props) {
    const exit = useExit();
    return <nav className={classNames("sticky top-0 z-10", className)}>
        <div className="flex justify-between items-center h-16 lg:h-20 px-8 py-4 lg:py-6 border-b border-gray-300 bg-white">
            <MyHealthLogo className="h-8" />
            {!hideCloseButton && <XClose className="h-6 w-6 cursor-pointer" onClick={() => exit()} />}
        </div>

        {progressBar &&
            <ProgressBar />}
    </nav>
}